<template>
  <div class="home">
    <div class="title_box">
      <h1 class="title">{{ title }}</h1>
      <h3 class="fu_title">基于GAN网络的智能文物图像修复系统</h3>
    </div>
    <div class="upload">
      <el-upload
        class="upload-demo"
        drag
        action=""
        multiple
        :on-success="handleSuccess"
        :before-upload="beforeUpload"
        :on-change="getFile"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">只能上传jpg/png文件</div>
      </el-upload>
    </div>
    <div v-if="imageUrl !== ''" class="content">
      <el-empty v-if="imageUrl == ''" description="请先上传图片"></el-empty>
      <div
        v-else
        class="img"
        v-loading="loading"
        element-loading-text="正在努力修复中"
      >
        <div class="filter" :style="{ width: num + '%' }">
          <img :src="imageUrl" />
        </div>
        <div class="noFilter">
          <img :src="imageUrlss" />
        </div>
      </div>
      <el-slider
        v-if="!loading"
        v-model="num"
        :show-tooltip="false"
      ></el-slider>
      <el-backtop target=".home" visibility-height="50"></el-backtop>
    </div>
  </div>
</template>

<script>
import Axios from 'axios';

export default {
  name: "Home",
  data() {
    return {
      title: "智新复古",
      imageUrl: "",
      imageUrlss:'',
      num: 0,
      count: 0,
      loading: false,
    };
  },
  methods: {
    numChange(val) {},
    getFile(file, fileList) {
      this.getBase64(file.raw).then((res) => {
        const params = res;
        this.num = 100;
        this.loading = true;
        this.imageUrl = params;
        if(this.count==0){
          axios.post('../imageRepair.php', {
          imgBase64:this.imageUrl.trim()
}).then(res=>{
  if(res.data.status==400){
    this.$message.error("修复过程中出现了未知错误");
  }else{
    this.imageUrlss='data:image/png;base64,'+res.data.data.image;
          this.num = 100;
          this.loading = false;
  }
      
      }).catch(err=> this.$message.error("修复过程中出现了未知错误666"));
      this.count++;
        }


      });
    },
    handleSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);


     
},
    beforeUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG/PNG 格式!");
      }

      return isJPG;
    },
    // 图片转base64编码
    getBase64(file) {
      return new Promise(function (resolve, reject) {
        const reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file);
        reader.onload = function () {
          imgResult = reader.result;
        };
        reader.onerror = function (error) {
          reject(error);
        };
        reader.onloadend = function () {
          resolve(imgResult);
        };
      });
    },
  },
}
</script>

<style scoped lang="scss">
.home {
  color: #fff;
  width: 100%;
  height: 100%;
  position: relative;
  background-image: url(../assets/image/wenwu.jpg);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center center;
  // background-color: #11131c;
  height: 100vh;
  overflow: auto;
  .title_box {
    padding: 50px;
    text-align: center;
    .title {
      color: #fff;
      margin-bottom: 15px;
    }
    .fu_title {
      color: #fff;;
      font-size: 35px;
    }
  }
  .upload {
    width: 60%;
    background-color: #fff;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 0 10px 1px #ccc;
    margin: 0 auto;
    text-align: center;
  }
  .content {
    width: 30%;
    background-color: #fff;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 0 10px 1px #ccc;
    margin: 0 auto;
    margin-top: 20px;
    .img {
      overflow: hidden;
      position: relative;
      .filter {
        width: 70%;
        height: 100%;
        filter: blur(0px);
        position: absolute;
        top: 0;
        left: 0;
        overflow: hidden;
        img {
          height: 100%;
        }
      }
      .noFilter {
        width: 100%;
        img {
          width: 100%;
        }
      }
    }
  }
}
::v-deep .el-upload {
  width: 100% !important;
  .el-upload-dragger {
    width: 100% !important;
  }
}
</style>
